import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UniversalForm, IField, UniversalFormRefType } from "../UniversalForm";
import { LoginFormScheme } from './LoginFormScheme';
import TroberButton from '../Components/TroberButton';
import api from '../API';
import { EQAuthParamType, TypeDomainParams } from 'src/Types/';
import { EQueueType } from 'src/Types/ReDoc/EQueue';

interface ILoginFormProps {
	redirect?: string;
	showErrorModal: ( type: string, msg?: string, title?: string ) => void;
};

const fields: Array<IField> = [
	{
		name: "login",
		placeholder: "Логин",
		type: "text"
	},
	{
		name: "password",
		placeholder: "Пароль",
		type: "password"
	}
];

const enterFields: Array<IField> = [
	...fields,
	{
		name: "pultId",
		title: "Номер окна",
		type: "text"
	}
];

const returnFields: Array<IField> = [
	{
		name: "pultId",
		title: "Номер окна",
		type: "text"
	}
];

/** Форма авторизации по логину и паролю  */
const LoginForm: React.FC<ILoginFormProps> = ( { showErrorModal, redirect  } ) => {

    const { t } = useTranslation();
	const formRef = useRef<UniversalFormRefType>(null);
    const [ isWaiting, setIsWaiting ] = useState(false);

	const onSaveHandler = async ( values: TypeDomainParams ) => {
		setIsWaiting(!isWaiting);
		try {
			const result = await api.Auth.Domain.login(values);
			const data = await result.text();
			if (result.status === 200) {
				const red = redirect ? redirect : window.mainURLRedirect;
				window.location.replace(red);
			} 
			else if ( result.status === 202 ) {
				if ( formRef.current ) {
					formRef.current.setErrorField( "login" );
					formRef.current.setErrorField( "password", "Неправильное имя пользователя или пароль" );
				}
			}
			else {
				const msg = data ? data : "Неверно введен логин или пароль. Попробуйте ввести данные заново, либо обратитесь в службу поддержки для восстановления доступа.";
				showErrorModal( "error", undefined, msg );
			}
		}
		catch (e:any) {
			console.warn(e);
			showErrorModal( "error", undefined, "Попробуйте войти другим способом или обратитесь в службу поддержки." );
		}
		finally {
			setIsWaiting(false);
		}
	};

	const toolbar = (isValid: boolean) => (
		<TroberButton id="login_btn_login-domain" style={{ marginTop: '8px' }} disabled={!isValid} type="submit" block isWaiting={isWaiting}>
			{t('login.byAccountBtn')}
		</TroberButton>
	);

	return (
		<UniversalForm
			ref={formRef}
            margin={24}
			disabled={isWaiting}
			renderToolbar={toolbar}
			cols={1} 
			formSchema={LoginFormScheme} 
			fields={fields} 
			onSaveHandler={onSaveHandler} 
		/>
	);
};

interface IEQ_LoginFormProps {
	isWaiting?: boolean;
    initFields?: EQAuthParamType;
	onSaveHandler: ( values: EQAuthParamType ) => void;
};

export const EQLoginForm: React.FC<IEQ_LoginFormProps> = ( { isWaiting = false, initFields, onSaveHandler }) => {

    const { t } = useTranslation();

	const toolbar = (isValid: boolean) => (
		<TroberButton style={{ marginTop: '12px'}} disabled={!isValid} type="submit" block isWaiting={isWaiting}>{t('login.byAccountBtn')}</TroberButton>
	);

	const getFields = (): Array<IField> => {
		switch (initFields?.type) {
			case EQueueType.Enter:
				return enterFields;
			case EQueueType.Return:
				return returnFields;
			default:
				return fields;
		}
	};

    return (
        <UniversalForm 
            margin={24}
            disabled={isWaiting}
            renderToolbar={toolbar}
            sourceData={initFields}
            cols={1} 
            formSchema={LoginFormScheme} 
            fields={ getFields() } 
            onSaveHandler={onSaveHandler} 
        />
	);
};


export default LoginForm;